/**
 * Local development override: flag values supplied as a JSON object in
 * `NEXT_PUBLIC_FEATURE_FLAG_VALUES`. Mirrors DevProvider on the API side
 * (api/src/feature-flags/feature-provider.ts).
 *
 * Unset in every deployed environment, so this module resolves to `null` there and
 * every read falls through to the other sources in `useFeatureFlags`.
 */
function parseLocalFlagOverrides(): Record<string, unknown> | null {
  const raw = process.env.NEXT_PUBLIC_FEATURE_FLAG_VALUES;

  if (!raw) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);

    // `JSON.parse` succeeds on any valid JSON, so `5`, `true` and `[1,2]` all
    // get this far. Spread into the flag set, an array or a string would
    // contribute its indices as flag keys.
    if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
      console.warn('NEXT_PUBLIC_FEATURE_FLAG_VALUES is not a JSON object — falling back to LaunchDarkly');
      return null;
    }

    return parsed;
  } catch {
    console.warn('NEXT_PUBLIC_FEATURE_FLAG_VALUES is not valid JSON — falling back to LaunchDarkly');
    return null;
  }
}

// Inlined at build time, so this is a module-level constant rather than a hook.
export const localFlagOverrides = parseLocalFlagOverrides();
